export default __webpack_public_path__ + "static/media/food-illu.740886ac.svg";